<div class="flex flex-col h-screen">
  <auto-editor-toolbar class="sticky top-0 w-full z-50"></auto-editor-toolbar>

  <auto-editor-view-content class="flex-1 grow overflow-y-auto overflow-x-hidden"></auto-editor-view-content>
</div>
